export default __webpack_public_path__ + "static/media/bone-1.ca70aab5.png";